import React from 'react';
import styled, { css, keyframes } from 'react-emotion';
import P from 'prop-types';

const DEFAULT_SPINNER_SIZE = 64;
const DOT_SIZE_RATIO = 0.2;

const Container = styled('div')`
   ${props => css`
      display: inline-block;
      position: relative;
      width: ${props.size}px;
      height: ${props.size}px;
   `};
`;

const spinAnimation = offset => keyframes`
   0% {
      transform: rotate(${offset}deg);
   }
   100% {
      transform: rotate(${offset + 360}deg);
   }
`;

const DotPosition = styled('div')`
   ${props => css`
      width: 100%;
      height: 100%;
      position: absolute;
      animation: ${spinAnimation(props.offset)} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      transform-origin: center;
      animation-delay: ${props.delay}s;
   `};
`;

const Dot = styled('div')`
   ${props => css`
      :after {
         width: ${props.size}px;
         height: ${props.size}px;
         background: ${props.color || props.theme.palettes.primary(500)};
         top: 0;
         left: 0;
         content: ' ';
         display: block;
         position: absolute;
         border-radius: 50%;
      }
   `};
`;

const DOTS_DEFINITION = [
   {
      delay: -0.288,
      offset: -45
   },
   {
      delay: -0.252,
      offset: -67.5
   },
   {
      delay: -0.216,
      offset: -90
   },
   {
      delay: -0.18,
      offset: -112.5
   },
   {
      delay: -0.144,
      offset: -135
   },
   {
      delay: -0.108,
      offset: -157.5
   },
   {
      delay: -0.072,
      offset: -180
   },
   {
      delay: -0.036,
      offset: -202.5
   }
];

const Spinner = ({ size, color }) => {
   const dotSize = size * DOT_SIZE_RATIO;
   return (
      <Container size={size}>
         {DOTS_DEFINITION.map((dot, idx) => (
            <DotPosition key={idx} delay={dot.delay} offset={dot.offset}>
               <Dot color={color} size={dotSize} />
            </DotPosition>
         ))}
      </Container>
   );
};

Spinner.propTypes = {
   size: P.number,
   color: P.string
};

Spinner.defaultProps = {
   size: DEFAULT_SPINNER_SIZE
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/UI/components/Spinner/Spinner.js